// extracted by mini-css-extract-plugin
module.exports = {"fadeIn":"Failed_fadeIn__3xsIs","FadeInAnimation":"Failed_FadeInAnimation__3rN0s"};